import { StandardLayoutHeaderWithPortal } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { usePunditUserContext } from "@circle-react/contexts";
import type { ViewSwitcherLayoutTypes } from "@circle-react-shared/ViewSwitcher";
import { MembersHeaderTitle } from "./HeaderTitle";
import { MembersSearch } from "./MemberSearch";
import { MembersFilters } from "./MembersFilters";
import { RightOptions } from "./RightOptions";

export interface HeaderProps {
  activeView: ViewSwitcherLayoutTypes;
  headerTitle?: string;
  memberCount: number;
  setActiveView: (value: ViewSwitcherLayoutTypes) => void;
  setShouldRenderMobileFiltersTransition: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

export const Header = ({
  memberCount,
  headerTitle,
  activeView,
  setShouldRenderMobileFiltersTransition,
  setActiveView,
}: HeaderProps) => {
  const { currentCommunityMember } = usePunditUserContext();

  return (
    <>
      <StandardLayoutHeaderWithPortal
        leftContent={
          <div className="flex flex-row items-center gap-6">
            <MembersHeaderTitle
              currentCommunityMember={currentCommunityMember}
              memberCount={memberCount}
              hasDropdown={false}
              headerTitle={headerTitle}
            />
          </div>
        }
        rightContent={
          <RightOptions activeView={activeView} setActiveView={setActiveView} />
        }
      />
      <MembersSearch
        setShouldRenderMobileFiltersTransition={
          setShouldRenderMobileFiltersTransition
        }
      />
      <MembersFilters />
    </>
  );
};
